import {
  Metrics,
  QuickActions,
  TodaySchedule,
  ActivityTabs,
  JobStatusOverview,
  ServiceStatusOverview,
} from "./components";

export function DashboardComponent() {
  return (
    <div className="space-y-6">
      <QuickActions />
      <ActivityTabs />
      <JobStatusOverview />
      <ServiceStatusOverview />
      <TodaySchedule />
      <Metrics />
    </div>
  );
}
